import p from './device-distribute-log.vue';

export default p;
